module.exports = __webpack_public_path__ + "img/cover-promotion-bg.0cd03b58.jpg";